import { render, staticRenderFns } from "./AdminAnalyticsYearly.vue?vue&type=template&id=6a28adca&scoped=true&"
import script from "./AdminAnalyticsYearly.vue?vue&type=script&lang=js&"
export * from "./AdminAnalyticsYearly.vue?vue&type=script&lang=js&"
import style0 from "./AdminAnalyticsYearly.vue?vue&type=style&index=0&id=6a28adca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a28adca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a28adca')) {
      api.createRecord('6a28adca', component.options)
    } else {
      api.reload('6a28adca', component.options)
    }
    module.hot.accept("./AdminAnalyticsYearly.vue?vue&type=template&id=6a28adca&scoped=true&", function () {
      api.rerender('6a28adca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminAnalyticsYearly.vue"
export default component.exports